<template>
  <div class="project-select">
    <div v-if="!hasMultipleAccounts" class="name">
      ({{ account.id}}) {{ account.name }}
    </div>
    <div v-else>
      <select class="input" v-model="selectAcc" @change="setNewAccount()">
        <option value="">Seleciona</option>
        <option v-for="(f, index) in accounts" :key="index" :value="f.id" :selected="f.id == selectAcc">
          {{ f.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { AccountsList } from "@/services/user";

export default {
  name: "ProjectSelector",
  props: ["hasMultipleAccounts"],
  data() {
    return {
      selectAcc: {},
      accounts: []
    };
  },
  mounted() {
    this.getAccounts()

    this.selectAcc = this.account.id
  },
  watch: {
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    setNewAccount() {

      var account = this.accounts.find( a => a.id == this.selectAcc)

      // set in store user and account selected
      this.$store.dispatch("auth", { account: account.id });
      this.$store.dispatch("setAccount", account);

      // redict to home
      this.$router.push({ name: "Home" });
    },
    getAccounts() {
      AccountsList()
      .then((response) => {
        this.accounts = response.map( c => {
          return {
            ...c,
            label: `(${c.id}) ${c.name}`
          }
        })
      })
      .catch((error) => {
        if (error && error.message === "request-canceled") {
          return;
        }

        this.$toast.error({
          title: "Erro",
          message: "Falhou ao buscar contas",
        });
      })
      .finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.input {
  max-width: 100px;
    max-height: 400px;
    overflow-y: scroll;
}
.project-select {
  padding-right: 12px;
  border-right: 1px solid var(--border);
  .name {
    margin-right: 12px;
    max-width: 200px;
  }
}

@media screen and (max-width: 1024px) {
  .project-select {

    .name {
      margin-right: 12px;
      max-width: 100px;
    }
  }
}
</style>